module.exports = __webpack_public_path__ + "assets/img/worldviewImg-b4c4f708.png";